import {
  TreeDataNode,
  TreeSelectProps,
} from 'antd'

import {
  Group,
  GroupType,
} from '@/model/group'
import { createAppSelector } from '@/redux/utils'

export interface GroupTreeData {
  title: string
  key: number
  value: number
  children: GroupTreeData[]
}

const emptyTreeDataNodes: TreeDataNode[] = []
const emptyTreeData: TreeSelectProps['treeData'] = []

const groupToTreeDataNode = (group: Group, allGroups: Group[]): TreeDataNode => {
  return {
    title: group.name,
    key: group.id,
    children: allGroups.filter(({ ancestorIds }) => ancestorIds.at(-1) === group.id).map(
      (item) => groupToTreeDataNode(item, allGroups)),
  }
}

const groupToTreeData = (group: Group, allGroups: Group[]): GroupTreeData => {
  return {
    key: group.id,
    title: group.name,
    value: group.id,
    children: allGroups.filter(({ ancestorIds }) => ancestorIds.at(-1) === group.id).map(
      (item) => groupToTreeData(item, allGroups)),
  }
}

export const selectGroupsByType = createAppSelector(
  [
    (state) => state.group.groups,
    (_, type: GroupType) => type,
  ],
  (groups, type) => groups.filter((item) => item.type === type),
)

export const selectGroupTreeInfo = createAppSelector(
  [selectGroupsByType],
  (groups) => {
    const rootGroup = groups.find(({ ancestorIds }) => ancestorIds.length === 0)

    if (!rootGroup) {
      return { treeDataNodes: emptyTreeDataNodes, groups }
    }

    return {
      treeDataNodes: [groupToTreeDataNode(rootGroup, groups)],
      rootGroupId: rootGroup.id,
      groups,
    }
  },
)

export const selectGroupTreeData = createAppSelector(
  [selectGroupsByType],
  (groups) => {
    const rootGroup = groups.find(({ ancestorIds }) => ancestorIds.length === 0)

    if (!rootGroup) {
      return emptyTreeData
    }

    return [groupToTreeData(rootGroup, groups)]
  },
)
